import { useDraggable } from '@dnd-kit/core';

type Props = {
  id: string | number;
  children: React.ReactNode;
};

export function DraggableCard({ id, children }: Props) {
  const { listeners, attributes, setNodeRef, isDragging } = useDraggable({
    id,
  });

  return (
    <div
      {...listeners}
      {...attributes}
      ref={setNodeRef}
      style={{
        opacity: isDragging ? 0.2 : 1,
        transition: 'opacity 0.2s ease',
        touchAction: 'none',
      }}
    >
      {children}
    </div>
  );
}
